import styled from "styled-components";

export const VerticalSeparator = styled.div<{ height?: string }>`
	width: 1px;
	height: ${(props) => props.height || "100%"};
	background: linear-gradient(
		to bottom,
		rgba(74, 74, 74, 0.5) 0%,
		rgba(255, 255, 255, 0.7) 50%,
		rgba(74, 74, 74, 0.5) 100%
	);
`;
